import React from 'react';
import { TagIcon, ArrowRightIcon } from 'lucide-react';
interface CallToAction8Props {
  destinationUrl?: string;
  buttonText?: string;
  productName?: string;
  descriptionText?: string;
}
export const CallToAction8 = ({
  destinationUrl = 'https://nivieorganics.com/pages/mineral-drops',
  buttonText = 'Access Offer',
  productName = 'BV Treatment Interest',
  descriptionText = ''
}: CallToAction8Props) => {
  // Function to preserve all tracking parameters
  const getTrackingUrl = () => {
    const searchParams = new URLSearchParams(window.location.search);
    if (!searchParams.has('fbclid') && localStorage.getItem('fbclid')) {
      searchParams.append('fbclid', localStorage.getItem('fbclid') || '');
    }
    return searchParams.toString() ? `?${searchParams.toString()}` : '';
  };
  // Track click on CTA button
  const handleClick = () => {
    if (window.fbq) {
      window.fbq('track', 'Lead', {
        content_name: productName,
        content_category: 'Product Interest'
      });
    }
  };
  return <div className="my-8 border border-slate-300 bg-white p-8 sm:p-10" data-id="element-2267">
      {/* Reader Access Label */}
      <div className="flex items-center gap-2 mb-6" data-id="element-2268">
        <TagIcon className="h-4 w-4 text-slate-600" data-id="element-2269" />
        <span className="text-sm font-medium text-slate-600 tracking-wide" data-id="element-2270">
          READER ACCESS
        </span>
      </div>
      {/* Product Name */}
      <h3 className="text-xl sm:text-2xl font-bold text-slate-900 mb-6" data-id="element-2271">
        {productName}
      </h3>
      {/* CTA Button */}
      <a href={`${destinationUrl}${getTrackingUrl()}`} target="_blank" rel="noopener noreferrer" className="block w-full bg-slate-900 hover:bg-slate-800 text-white font-medium py-4 px-6 text-center transition flex items-center justify-center gap-2" onClick={handleClick} data-id="element-2272">
        {buttonText}
        <ArrowRightIcon className="h-5 w-5" data-id="element-2273" />
      </a>
      {/* Optional Description Text */}
      {descriptionText && <p className="text-sm text-slate-600 text-center mt-4" data-id="element-2274">
          {descriptionText}
        </p>}
    </div>;
};